<template>

  <div class="dialog" v-if="dialogVisible">
    <span class="close" @click="openDialog(false)"></span>
    <div class="paper">
      <div class="header"> <h1>원사정보 수정</h1> <span @click="openDialog(false)">X</span> </div>

      <form>
        <div class="item">
          <label>이름</label>
          <input type="text" v-model="editingCompany.name" placeholder="이름" />
        </div>
        <div class="item">
          <label>구분</label>
          <select v-model="editingCompany.type">
            <option value="life">생명</option>
            <option value="fire">손해</option>
            <option value="other">기타</option>
          </select>
        </div>
        <div class="item">
          <label>순서</label>
          <input type="number" min="0" v-model="editingCompany.no" placeholder="정렬 순서" />
        </div>
        <div class="item">
          <label>이미지 주소</label>
          <input type="text" v-model="editingCompany.short_img" placeholder="이미지 주소" />
        </div>
        <div class="item">
          <label>전산링크</label>
          <input type="text" v-model="editingCompany.system_url" placeholder="전산링크" />
        </div>
        <div class="item">
          <label>전화</label>
          <input type="text" v-model="editingCompany.phone" placeholder="전화" />
        </div>
        <div class="item">
          <label>구 이름</label>
          <ul>
            <li v-for="(name, index) in JSON.parse(editingCompany.old_name)" :key="index">
              <span>{{ name }}</span>
              <button @click="removeOldName(index)"><i class="ph ph-x"></i></button>
            </li>
          </ul>
        </div>
        <div class="btns">
          <button type="button" @click="openDialog(false)" >취소</button>
          <button type="button" @click="saveCompany" class="confirm">확인</button>
        </div>
      </form>
    </div>
  </div>

  <div class="admin-main">
    
    <div class="header">
      <h2>보험원사 정보관리</h2>
    </div>

    <div class="content">
      <ul>
        <li class="chapter">
          <div style="flex:1;">순서</div>
          <div style="flex:1;">구분</div>
          <div style="flex:1;">사진</div>
          <div>이름</div>
          <div>링크</div>
          <div>전화</div>
          <div>관리</div>
        </li>
        <li v-for="company in insuCompanys" :key="company.no">
          <div style="flex:1;">{{ company.no }}</div>
          <div style="flex:1;">{{ convertType(company.type) }}</div>
          <div style="flex:1;"> <img :src="company.short_img" /></div>
          <div>{{ company.name }}</div>
          <!-- <div>{{ company.old_name }}</div> -->
          <!-- <div>{{ company.value }}</div> -->
          <div> <a :href="company.system_url">전산 링크</a></div>
          <div>{{ company.phone }}</div>
          <div><button @click="editCompany(company)">수정</button></div>
        </li>
      </ul>
    </div>

  </div>
</template>


<script>
import { inject, ref } from 'vue';



export default {
  name: "insuCompanyAdmin",
  setup() {
    const sql_query = inject(`sql_query`);

    const dialogVisible = ref(false);
    const editingCompany = ref({});

    function convertType(type) {
      switch (type) {
        case 'life':
          return '생명';
        case 'fire':
          return '손해';
        default:
          return '기타';
      }
    }

    const insuCompanys = ref([]);
    async function getInsuCompanys() {
      const sql = `SELECT * FROM insu_company ORDER BY sort_no ASC`;
      try {
        const result = await sql_query(sql);
        insuCompanys.value = result.map(row => ({
          idx: row.idx,
          no:row.sort_no,
          name: row.name,
          type: row.type,
          old_name: row.old_name,
          value: row.code,
          system_url: row.system_url,
          phone: row.phone,
          short_img: row.short_img,
          long_img: row.long_img
        }));
      } catch (error) {
        console.error('❌ 보험사 정보 조회 실패:', error);
      }
    }
    getInsuCompanys();

    function openDialog(b) {
      dialogVisible.value = b;
      // input 비우기
    }

    function editCompany(company) {
      editingCompany.value = { ...company };
      openDialog(true);
    }

    async function saveCompany() {
      const sql = `UPDATE insu_company SET name = '${editingCompany.value.name}', sort_no = '${editingCompany.value.no}', short_img = '${editingCompany.value.short_img}' WHERE idx = '${editingCompany.value.idx}'`;
      try {
        await sql_query(sql);
        getInsuCompanys();
        openDialog(false);
      } catch (error) {
        console.error('❌ 보험사 정보 수정 실패:', error);
      }
    }

    function removeOldName(index) {
      const oldNames = JSON.parse(editingCompany.value.old_name);
      oldNames.splice(index, 1);
      editingCompany.value.old_name = JSON.stringify(oldNames);
    }

    return {
      insuCompanys,
      convertType,
      openDialog,
      dialogVisible,
      editingCompany,
      saveCompany,
      editCompany,
      removeOldName
    }
  }
};

</script>


<style scoped>


.dialog {
  width:100%;
  height:100%;
  position: absolute;
  left:0;
  top:0;
  background-color: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9;
}

.dialog > .close {
  position: absolute;
  z-index: -1;
  right: 0;
  top: 0;
  width:100%;
  height:100%;
}

.dialog > .paper {
  position: relative;
  width: 100%;
  max-width:600px;
  height: 80%;
  background-color: var(--color-background);
  border:1px solid var(--color-text-primary);
  border-radius: 16px;
  padding: 16px;
  box-sizing: border-box;
  overflow:scroll;
}

.dialog > .paper::-webkit-scrollbar {
  display: none;
}

.dialog > .paper > .header {
  width:100%;
  height:48px;
  display:flex;
  justify-content: space-between;
  align-items: center;
  font-size: var(--font-size-lg);
}

.dialog > .paper > .header > h1 {
  font-size:20px;
}

.dialog > .paper > .header > span {
  width:48px;
  height:48px;
  display:flex;
  justify-content: center;
  align-items: center;
  cursor:pointer;
}

.dialog > .paper > form {
  width:100%;
  height:fit-content;
  display:flex;
  flex-direction: column;
  gap:12px;
}

.dialog > .paper > form > .item {
  width:100%;
  height:fit-content;
  display:flex;
  flex-direction: column;
  gap:6px;
}

.dialog > .paper > form > .item > label {
  font-size:16px;
  color: var(--color-text-primary);
}

.dialog > .paper > form > .item > input,
.dialog > .paper > form > .item > textarea,
.dialog > .paper > form > .item > select {
  width:100%;
  height:40px;
  border:1px solid var(--color-text-secondary);
  border-radius:8px;
  padding:8px;
  box-sizing: border-box;
  font-size:16px;
  color: var(--color-text-primary);
}

.dialog > .paper > form > .item > textarea  {
  height:80px;
}

.dialog > .paper > form .item ul {
  width:100%;
  display:Flex;
  flex-wrap: wrap;
  gap:12px;
  list-style: none;
  padding:0;
  margin:0;
}

.dialog > .paper > form .item ul > li {
  width:fit-content;
  height:fit-content;
  background: var(--color-background-light);
  padding:6px 12px;
  box-sizing: border-box;
  font-size: 14px;
  border-radius: 6px;
  display:flex;
  gap:8px;
  align-items: center;
  justify-content: center;
}

.dialog > .paper > form .item ul > li > button {
  width:24px;
  height:24px;
  background:none;
  display:flex;
  align-items: center;
  justify-content: center;
  border:none;
  padding:0;
  font-size:16px;
  cursor: pointer;
}

.dialog > .paper > form > .btns {
  position: absolute;
  bottom:16px;
  left:16px;
  width:95%;
  height:fit-content;
  display:flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
  gap:12px;
}

.dialog > .paper > form > .btns > button {
  width:100%;
  height:40px;
  flex:1;
  background-color: var(--color-background-light);
  color: var(--color-text-primary);
  border:none;
  border-radius:8px;
  cursor:pointer;
  font-size:16px;
  font-weight: 700;
}

.dialog > .paper > form > .btns > button.confirm {
  background-color: var(--color-brand);
  color: var(--color-text-black);
}

.admin-main {
  width:100%;
  height: 100%;
  display:flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  background-color: var(--color-background);
}

.admin-main > .header { 
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: start;
  align-items: center;
  color: var(--color-text-primary);
  border-bottom: 1px solid var(--color-surface-reverse);
  padding:16px;
  box-sizing: border-box;
}

.admin-main .header {
  width:100%;
  display:flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
}

.admin-main .header > h2 {
  font-size: 24px;
  color: var(--color-text-primary);
  display:flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  padding:0;
  margin:0;
  gap:12px;
}

.admin-main .header > h2 > b {
  font-size:36px;
}

.content {
  width:100%;
  height:90%;
  flex:1;
  padding:16px;
  box-sizing: border-box;
  display:flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  gap:16px;
}

.content > ul {
  width:100%;
  height:100%;
  overflow-y:auto;
  list-style: none;
  padding:0;
  margin:0;
  display:Flex;
  flex-direction: column;
  gap:12px;
}

.content > ul > li {
  display:flex;
  align-items: center;
  justify-content: start;
}

.content > ul > li:hover {
  background-color: var(--color-background-light);
}

.content > ul > li img {
  width:36px;
  height:36px;
  object-fit: contain;
  border-radius: 6px;
}

.content > ul > li > div {
  flex:5;
  display:flex;
  align-items: center;
  justify-content: center;
}
</style>